// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--060f5";
export var footerMain = "footer-module--footerMain--c1be7";
export var footerSocial = "footer-module--footer-social--08a07";